const upsertRoleAccessPayload = (formData, hostMenu) => {
  const isBackoffice = formData?.accessType.value === 'Desktop Website';

  const menus = isBackoffice ? formData?.operatorMenu : hostMenu;

  const payload = {
    isHost: formData?.isHost,
    isOperator: formData?.isOperator,
    name: formData?.name,
    menus,
    isBackoffice,
  };

  return payload;
};

export default upsertRoleAccessPayload;
